// Mirrors backend services/tax.py (rates in 1/10000 of a percent, half-up to the cent).
export const taxCents = (amountCents, rateBp) => Math.floor((amountCents * rateBp + 500000) / 1000000);

export const cityFromZip = (zip, taxData) => {
  if (!taxData || !/^\d{5}$/.test(zip)) return null;
  if (taxData.zip_to_city[zip]) return taxData.zip_to_city[zip];
  const prefix = Object.keys(taxData.zip_prefix_to_city).find((p) => zip.startsWith(p));
  return prefix ? taxData.zip_prefix_to_city[prefix] : null;
};

export const rateForCity = (city, taxData) =>
  taxData?.rates.find((r) => r.city === city) || null;

export const fmtUsd = (cents) => `$${(cents / 100).toFixed(2)}`;
